var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTorq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6092 11H35.2228C36.7566 11 38 12.2434 38 13.7772V16.9339H22.6092V11Z",
    fill: "#00A5C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7616 37.5906H12.7772C11.2434 37.5906 10 36.3472 10 34.8134V31.6567H25.7616V37.5906Z",
    fill: "#00A5C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.31H38V27.4293H10V21.31Z",
    fill: "#00A5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorq);
export default __webpack_public_path__ + "static/media/torq.9b33fab52961f0be716e3503c6f82bb5.svg";
export { ForwardRef as ReactComponent };